export const formatMs = (ms) => {
  if (ms === null || ms === undefined || Number.isNaN(ms)) {
    return "--";
  }
  const seconds = ms / 1000;
  if (seconds < 60) {
    return `${seconds.toFixed(2)}s`;
  }
  const minutes = Math.floor(seconds / 60);
  const remaining = (seconds % 60).toFixed(2).padStart(5, "0");
  return `${minutes}m ${remaining}s`;
};

export const formatPercent = (value) => {
  if (!value || Number.isNaN(value)) {
    return "0%";
  }
  return `${(value * 100).toFixed(1)}%`;
};